var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_899_1000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8236 7.3002C21.6666 6.5316 22.2 5.4282 22.2 4.2C22.2 1.8846 20.316 0 18 0C15.684 0 13.8 1.8846 13.8 4.2C13.8 5.4282 14.3334 6.5316 15.1764 7.3002C12.687 7.7802 10.8 9.9726 10.8 12.6V15C10.8 15.3318 11.0688 15.6 11.4 15.6H24.6C24.9312 15.6 25.2 15.3318 25.2 15V12.6C25.2 9.9726 23.313 7.7802 20.8236 7.3002ZM15 4.2C15 2.5458 16.3458 1.2 18 1.2C19.6542 1.2 21 2.5458 21 4.2C21 5.8542 19.6542 7.2 18 7.2C16.3458 7.2 15 5.8542 15 4.2ZM24 14.4H12V12.6C12 10.2846 13.884 8.4 16.2 8.4H19.8C22.116 8.4 24 10.2846 24 12.6V14.4Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0236 27.7002C10.8666 26.9316 11.4 25.8282 11.4 24.6C11.4 22.2846 9.516 20.4 7.2 20.4C4.884 20.4 3 22.2846 3 24.6C3 25.8282 3.5334 26.9316 4.3764 27.7002C1.887 28.1802 0 30.3726 0 33V35.4C0 35.7318 0.2688 36 0.6 36H13.8C14.1312 36 14.4 35.7318 14.4 35.4V33C14.4 30.3726 12.513 28.1802 10.0236 27.7002ZM4.2 24.6C4.2 22.9458 5.5458 21.6 7.2 21.6C8.8542 21.6 10.2 22.9458 10.2 24.6C10.2 26.2542 8.8542 27.6 7.2 27.6C5.5458 27.6 4.2 26.2542 4.2 24.6ZM13.2 34.8H1.2V33C1.2 30.6846 3.084 28.8 5.4 28.8H9C11.316 28.8 13.2 30.6846 13.2 33V34.8Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6237 27.7002C32.4667 26.9316 33.0001 25.8282 33.0001 24.6C33.0001 22.2846 31.1161 20.4 28.8001 20.4C26.4841 20.4 24.6001 22.2846 24.6001 24.6C24.6001 25.8282 25.1335 26.9316 25.9765 27.7002C23.4871 28.1802 21.6001 30.3726 21.6001 33V35.4C21.6001 35.7318 21.8689 36 22.2001 36H35.4001C35.7313 36 36.0001 35.7318 36.0001 35.4V33C36.0001 30.3726 34.1131 28.1802 31.6237 27.7002ZM25.8001 24.6C25.8001 22.9458 27.1459 21.6 28.8001 21.6C30.4543 21.6 31.8001 22.9458 31.8001 24.6C31.8001 26.2542 30.4543 27.6 28.8001 27.6C27.1459 27.6 25.8001 26.2542 25.8001 24.6ZM34.8001 34.8H22.8001V33C22.8001 30.6846 24.6841 28.8 27.0001 28.8H30.6001C32.9161 28.8 34.8001 30.6846 34.8001 33V34.8Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6114 19.1808L2.4126 19.2276C2.4288 19.641 2.4618 20.0598 2.511 20.4714L3.7026 20.3286C3.657 19.9488 3.6264 19.5624 3.6114 19.1808Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5104 16.7382C2.4618 17.1474 2.4282 17.5656 2.4126 17.9814L3.6114 18.0282C3.6264 17.6442 3.657 17.2584 3.702 16.8798L2.5104 16.7382Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.54347 6.1908C8.21527 6.441 7.89187 6.7086 7.58167 6.987L8.38386 7.8798C8.66946 7.623 8.96767 7.3758 9.27067 7.1454L8.54347 6.1908Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88016 11.958C3.70376 12.333 3.54056 12.7194 3.39417 13.1088L4.51736 13.5306C4.65236 13.1718 4.80296 12.8154 4.96556 12.4704L3.88016 11.958Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.00186 14.2938C2.88786 14.6904 2.78887 15.099 2.70667 15.5058L3.88326 15.7428C3.95886 15.3678 4.05006 14.991 4.15566 14.6244L3.00186 14.2938Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6882 7.85815C6.4008 8.16056 6.1248 8.47556 5.8656 8.79536L6.7986 9.55016C7.0374 9.25496 7.293 8.96336 7.5582 8.68436L6.6882 7.85815Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6398 4.84265C10.2768 5.03645 9.91495 5.24945 9.56335 5.47565L10.2138 6.48485C10.5378 6.27545 10.8714 6.07925 11.2049 5.90105L10.6398 4.84265Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.12039 9.79504C4.88579 10.1376 4.66259 10.4928 4.45679 10.8522L5.49779 11.4486C5.68739 11.1174 5.89379 10.7892 6.11039 10.4736L5.12039 9.79504Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4207 6.99182L27.6191 7.88462C27.9047 8.14142 28.1819 8.41142 28.4441 8.68742L29.3153 7.86242C29.0309 7.56242 28.7303 7.26962 28.4207 6.99182Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1367 8.79895L29.2037 9.55375C29.4431 9.84955 29.6747 10.161 29.8919 10.4778L30.8813 9.79915C30.6461 9.45655 30.3959 9.11995 30.1367 8.79895Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5875 17.9832L32.3887 18.03C32.3965 18.219 32.4001 18.4098 32.4001 18.6C32.4001 18.795 32.3965 18.9888 32.3887 19.1826L33.5875 19.2294C33.5959 19.0206 33.6001 18.8106 33.6001 18.5988C33.6001 18.393 33.5959 18.1872 33.5875 17.9832Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5456 10.8552L30.504 11.4522C30.6942 11.784 30.873 12.1278 31.0362 12.4734L32.1216 11.961C31.9452 11.5866 31.7514 11.2146 31.5456 10.8552Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.607 13.1112L31.4838 13.5336C31.6182 13.8912 31.7394 14.259 31.845 14.6262L32.9988 14.2956C32.8848 13.8972 32.7528 13.4988 32.607 13.1112Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2927 15.5082L32.1167 15.7446C32.1923 16.1202 32.2535 16.503 32.2979 16.8822L33.4895 16.7406C33.4409 16.3302 33.3749 15.9156 33.2927 15.5082Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4401 5.47803L25.7903 6.48723C26.1107 6.69363 26.4275 6.91623 26.7329 7.14963L27.4613 6.19503C27.1307 5.94243 26.7875 5.70183 26.4401 5.47803Z",
    fill: "#EB9309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2424 4.29968L23.7618 5.39888C24.1116 5.55188 24.4596 5.72108 24.7974 5.90228L25.365 4.84508C24.9996 4.64828 24.6216 4.46468 24.2424 4.29968Z",
    fill: "#EB9309"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_899_1000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.7fdc6e6d4b4fcb567f755b26ab8ddfd3.svg";
export { ForwardRef as ReactComponent };